import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-code-icon',
  standalone: true,
  templateUrl: './code-icon.component.html',
  styleUrls: ['./code-icon.component.scss']
})
export class CodeIconComponent {
  @Input() width: number | string = 20;
  @Input() height: number | string = 20;
}
